import { Treatment } from "@shuttlerock/api-types/federated";
import { ConfigService } from "@shuttlerock/configuration";
import { request } from "graphql-request";
import { MeQuery } from "../graphql/queries/me.graphql";
import { FetchUserError } from "./errors";

export type UserData = {
  principalKey: string | undefined;
  key: string;
  fullName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  picture: string | undefined;
  treatments: Treatment[];
};

/**
 * Queries our API for the current users details.
 * Internal to `@shuttlerock/auth`.
 */
export async function getUserData(accessToken: string): Promise<UserData | undefined> {
  try {
    const name = "src-web";
    const version = ConfigService.APP_VERSION();
    const response = await request(ConfigService.SUPERGRAPH_BASE_URL(), MeQuery, undefined, {
      Authorization: `Bearer ${accessToken}`,
      "x-client-id": [name, version].filter(Boolean).join(";"),
      "apollographql-client-name": name,
      ...(version && { "apollographql-client-version": version }),
    });

    const user = response.me?.user;
    const principalKey = response.me?.principal?.key;
    const treatments = response.me?.treatments ?? [];
    if (!user) {
      return undefined;
    }

    return {
      principalKey: principalKey ?? undefined,
      key: user.key,
      fullName: user.fullName ?? undefined,
      firstName: user.firstName ?? undefined,
      lastName: user.lastName ?? undefined,
      email: user.email ?? undefined,
      picture: user.picture ?? undefined,
      treatments,
    };
  } catch (e) {
    if (e instanceof Error) {
      throw new FetchUserError(e.message);
    }

    console.error(e);
    throw new FetchUserError(`An unexpected error occurred: ${e}`);
  }
}
